import * as firebase from 'firebase';
import 'firebase/database';
import 'firebase/firebase-database';

const firebaseConfig = {
  // produccion
  // apiKey: 'AIzaSyCx2hzCMZuWenkJ7l30b2oSBFSoQ3U_3VU',
  // authDomain: 'pmo-app-291722.firebaseapp.com',
  // databaseURL: 'https://pmo-app-291722.firebaseio.com',
  // projectId: 'pmo-app-291722',
  // storageBucket: 'pmo-app-291722.appspot.com',
  // messagingSenderId: '663134588643',
  // appId: '1:663134588643:web:ec1071cabd6a25e2053fd6',

  // qa
  apiKey: 'AIzaSyBG7m3bd-nWXPyCyN8OiQGNK7clYvxFHn4',
  authDomain: 'compratudepa-online.firebaseapp.com',
  projectId: 'compratudepa-online',
  storageBucket: 'compratudepa-online.appspot.com',
  messagingSenderId: '144751825819',
  appId: '1:144751825819:web:f6490d06ecd16212ec073e',
  measurementId: 'G-HSB4DQV1L9',
};

firebase.initializeApp(firebaseConfig);
export default firebase;
